<template>
  <div class="new-box">
    <div class="type_box">
      <p>请选择会员类型</p>
      <van-dropdown-menu>
        <van-dropdown-item v-model="mode" :options="option1" />
      </van-dropdown-menu>
    </div>
    <van-field
      class="input-item"
      :type="isShowPW?'password':''"
      left-icon="lock"
      :right-icon="isShowPW?'closed-eye':'eye-o'"
      @click-right-icon="isShowPW = !isShowPW"
      v-model="password"
      placeholder="请输入您的登录密码"
    ></van-field>
    <van-field
      class="input-item"
      :type="isShowPW2?'password':''"
      left-icon="lock"
      :right-icon="isShowPW2?'closed-eye':'eye-o'"
      @click-right-icon="isShowPW2 = !isShowPW2"
      v-model="password2"
      placeholder="请再次输入您的登录密码"
    ></van-field>
    <van-button class="nextBtn" type="primary" size="large" @click="check">下一步</van-button>
  </div>
</template>

<script>
import { Field, Button,Toast,DropdownMenu,DropdownItem  } from "vant";
import { setNewPW } from "@/api/login";
export default {
  data() {
    return {
      isShowPW: true,
      isShowPW2: true,
      mode:1,
      password: "",
      password2: "",
      warmCode:0,
      option1: [
        { text: '网员(快捷方式)', value: 9 },
        { text: '个人会员', value: 1 },
        { text: '团体会员', value: 2 }
      ],
    };
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
  },
  props: {
    mobile: {
      type: String,
      default: ""
    }
  },
  methods: {
    totalPass() {
      this.showPass = !this.showPass;
    },
    totalPassMore() {
      this.showPassMore = !this.showPassMore;
    },
    check() {
      let isChecked = this.$regexp.password(this.password),
           password = this.password,
          password2 = this.password2,
          regexpPassword = this.$regexp.chinese(password),
        params = {
          mobile: this.mobile,
          memberCategory: this.mode,
          password: this.password
        };

      if (!password) {
        Toast("请输入旧密码");
        return false;
      } else if (!password2) {
        Toast("请输入新密码");
        return false;
      } 
      else if (!isChecked || regexpPassword ) {
        Toast("密码必须为8-16为包含字母、数字、符号中至少2种且不能有空格");
        return;
      } else if (password !== this.password2) {
       Toast("两次密码不一致");
        return;
      }

      setNewPW(params).then(res => {
        if (res.success) {
          this.$emit("success",this.password);
        } else {
          Toast.fail("设置失败，请确定会员类型！");
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.new-box {
  padding: 0 10px;
  margin-top: 15px;
}
.input-item {
  padding: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #dfdfdf;

  i {
    color: #aaa;
    margin-right: 10px;
  }
  & + .input-item {
    margin-top: 30px;
  }
}
.nextBtn {
  margin-top: 35px;
}
.type_box{ overflow: hidden; border-bottom: #dfdfdf solid 1px; margin-bottom: 20px; margin-top: -10px;}
.type_box p{ float: left; font-size: 15px; height: 50px; line-height: 50px;}
.van-hairline--top-bottom::after,.van-cell:not(:last-child)::after{ border:none; }
.van-dropdown-menu { float: right; margin-right: 11px;}
</style>
